import type { ComponentPublicInstance } from "vue";
import { ErrorHandler } from "./ErrorHandler";

class GlobalError {
  handler(err: unknown, instance: ComponentPublicInstance | null, info: string) {
    ErrorHandler.handleGlobalError(err);
  }
}
export default new GlobalError();
